import React from "react";

interface StatusBadgeProps {
  type: string;
  status: string;
  className?: string;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ type, status, className = "" }) => {
  const getColorByType = () => {
    switch (type) {
      case "Health Insurance":
        return "border-[#CEE2D4] bg-[#2D9E7F]";
      case "Life Insurance":
        return "border-[#E9D6D4] bg-[#DD7B43]";
      case "Motor Insurance":
        return "border-[#C1DDED] bg-[#4493C0]";
      default:
        return "border-[#E5E4E2] bg-[#C0C0C0]";
    }
  };
  const patchColor = () => {
    switch (type) {
      case "Health Insurance":
        return "bg-[#CEE2D4]";
      case "Life Insurance":
        return "bg-[#E9D6D4]";
      case "Motor Insurance":
        return "bg-[#C1DDED]";
      default:
        return "bg-[#E5E4E2]";
    }
  };

  return (
    <div className={`relative inline-flex items-center justify-end ${className}`}>
      <div className={`flex gap-4 text-white py-1 px-4 rounded-tr-lg rounded-tl-lg  text-center font-bold text-[11px] ${getColorByType()}`}>
        <div className={`w-1.5 h-4 rounded-tr-lg rounded-br-lg  ${patchColor()} -ml-4`}></div>
        {status}
      </div>
    </div>
  );
};
